import React from "react";
import { Pricingblock } from "./Props";
import 'aos/dist/aos.css';

const Pricing = () => {
    return (
        <>
            <div className="Pricing-main" id="Pricing">
                <div className="container">
                    <div className="Pricing-inner">
                        <div className="title1" data-aos="fade-right">
                            <div className="title-inner">
                                <span>Shooting</span>
                                <h2>Pricing Tables</h2>
                            </div>
                        </div>
                        <div className="prirow-main">
                            <div className="pricing-info-inner">
                                <Pricingblock photo="../assets/img/3-3.jpg" titel="Standart" dollar="$" price="300" time="3 Hours Session" editing="Photo Editing" info="50 Digital Images" gallery="Online Gallery" />
                                <Pricingblock photo="../assets/img/2-3.jpg" titel="Premium" dollar="$" price="450" time="6 Hours Session" editing="Photo Editing" info="100 Digital Images" gallery="Online Gallery" />
                                <Pricingblock photo="../assets/img/1-3.jpg" titel="Platinum" dollar="$" price="750" time="12 Hours Session" editing="Photo Editing" info="250 Digital Images" gallery="Online Gallery" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Pricing;